import { HelpCircle, Briefcase } from "lucide-react";

/**
 * "If I were your banker, here's what I'd ask" — 6-8 questions a senior
 * commercial banker would raise given the report's numbers. Surfaces the
 * conversations the owner can rehearse for (or fix the underlying issue
 * for) before a real lender meeting.
 */
export default function BankerQuestionsCard({ questions }) {
  if (!questions || questions.length === 0) return null;
  return (
    <div className="mb-6" data-testid="banker-questions-card">
      <div className="bg-white border border-[#E5E0D8] rounded-2xl overflow-hidden">
        <div className="bg-[#1F382E] text-[#F7F5F0] px-6 sm:px-8 py-5 flex items-center gap-3">
          <div className="h-9 w-9 rounded-full bg-[#C26D5C]/20 flex items-center justify-center shrink-0">
            <Briefcase size={16} strokeWidth={1.75} className="text-[#C26D5C]" />
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.24em] text-[#C26D5C] font-medium">
              If I were your banker
            </p>
            <p className="font-serif-display text-xl sm:text-2xl text-[#F7F5F0] mt-0.5 tracking-tight leading-tight">
              The questions these numbers raise — rehearse before the meeting.
            </p>
          </div>
        </div>
        <ol className="divide-y divide-[#E5E0D8]">
          {questions.map((q, i) => (
            <li
              key={i}
              className="px-6 sm:px-8 py-5"
              data-testid={`banker-question-${i}`}
            >
              <div className="flex items-start gap-3">
                <span className="font-serif-display text-xl text-[#C26D5C] tabular-nums leading-none mt-1 shrink-0">
                  Q{i + 1}.
                </span>
                <div className="min-w-0">
                  <p className="text-[10px] uppercase tracking-[0.18em] text-[#5C665D] font-medium mb-1.5">
                    {q.category}
                  </p>
                  <p className="text-[14.5px] text-[#1A1A1A] leading-relaxed font-medium">
                    "{q.question}"
                  </p>
                  <div className="flex items-start gap-2 mt-2.5">
                    <HelpCircle
                      size={13}
                      strokeWidth={1.5}
                      className="text-[#5C665D] mt-0.5 shrink-0"
                    />
                    <p className="text-[12.5px] text-[#5C665D] leading-relaxed italic">
                      <span className="font-medium not-italic text-[#1F382E]">Why they ask:</span>{" "}
                      {q.why}
                    </p>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
